<smrts-dialog [title]="title" [hasFootnote]="true">

  <div class="custom-table">

    <div class="secao-header inline-element">
      <h3 class="accent-color secao-titulo">Regra</h3>
      <i class="pi pi-info-circle info-icon"
        pTooltip="O termo definido é comparado com a descrição do lançamento do extrato, de acordo com o tipo de verificação escolhido ao lado. Ao encontrar correspondência, os lançamentos abaixo são criados automaticamente e a conciliação é feita. Termos de tipos diferentes podem se sobrepor (você será avisado ao salvar); quando isso acontece, prevalece a regra de maior prioridade: Igual a, depois Começa com, depois Contém."></i>
    </div>

    <div class="custom-table-row">
      <div class="custom-table-col one-column-width">
        <app-generic-autocomplete
          [items]="opcoesTipoVerificacao"
          displayField="label"
          label="Tipo de verificação"
          inputId="tipoVerificacao"
          [ngModel]="opcaoTipoVerificacaoSelecionada"
          (selectionChange)="opcaoTipoVerificacaoSelecionada = $event">
        </app-generic-autocomplete>
      </div>

      <div class="custom-table-col one-column-width">
        <p-floatlabel variant="on">
          <input id="termoBusca" pInputText type="text" [(ngModel)]="regraForm.termoBusca" style="width: 100%" />
          <label>Termo de busca</label>
        </p-floatlabel>
      </div>
    </div>

    <div class="custom-table-row">
      <div class="custom-table-col one-column-width">
        <p-floatlabel variant="on">
          <input id="observacaoRegra" pInputText type="text" [(ngModel)]="regraForm.observacao" style="width: 100%" />
          <label>Observação da regra</label>
        </p-floatlabel>
      </div>

      <div class="custom-table-col one-column-width">
        <p-floatlabel variant="on">
          <input id="loteLancamento" pInputText type="text" [(ngModel)]="regraForm.loteLancamento" style="width: 100%" />
          <label>Nome do lote de lançamento</label>
        </p-floatlabel>
      </div>
    </div>

    <div class="secao-header inline-element">
      <h3 class="accent-color secao-titulo">Origem</h3>
      <i class="pi pi-info-circle info-icon"
        pTooltip="Lançamento criado na própria conta bancária, com valor oposto ao do extrato. Será conciliado automaticamente com o lançamento do extrato ao salvar."></i>
    </div>

    <div class="custom-table-row">
      <div class="custom-table-col one-column-width">
        <app-generic-autocomplete
          [items]="tiposOrigem"
          displayField="nome"
          label="Tipo de lançamento de origem"
          inputId="tipoOrigem"
          [ngModel]="tipoOrigemSelecionado"
          (selectionChange)="tipoOrigemSelecionado = $event">
        </app-generic-autocomplete>
      </div>

      <div class="custom-table-col one-column-width">
        <p-floatlabel variant="on">
          <input id="observacaoOrigem" pInputText type="text" [(ngModel)]="regraForm.observacaoOrigem" style="width: 100%" />
          <label>Observação do lançamento de origem</label>
        </p-floatlabel>
      </div>
    </div>

    <div class="secao-header inline-element">
      <h3 class="accent-color secao-titulo">Destino</h3>
      <i class="pi pi-info-circle info-icon"
        pTooltip="Lançamento criado na conta escolhida abaixo, com o mesmo valor do extrato. Indica a que o lançamento do extrato realmente se refere."></i>
    </div>

    <div class="custom-table-row">
      <div class="custom-table-col one-column-width">
        <app-generic-autocomplete
          [items]="tiposDestino"
          displayField="nome"
          label="Tipo de lançamento de destino"
          inputId="tipoDestino"
          [ngModel]="tipoDestinoSelecionado"
          (selectionChange)="tipoDestinoSelecionado = $event">
        </app-generic-autocomplete>
      </div>

      <div class="custom-table-col one-column-width">
        <p-floatlabel variant="on">
          <input id="observacaoDestino" pInputText type="text" [(ngModel)]="regraForm.observacaoDestino" style="width: 100%" />
          <label>Observação do lançamento de destino</label>
        </p-floatlabel>
      </div>
    </div>

  </div>

  <div footnote class="inline-element footnote">
    <button class="accent-text-button btn-cancelar" mat-button [mat-dialog-close]="false">
      Cancelar
    </button>
    <button class="white-text-button" mat-flat-button (click)="salvarClick()" [disabled]="salvando">
      {{ salvando ? 'Salvando...' : 'Salvar' }}
    </button>
  </div>
</smrts-dialog>
